module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.71ad32ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/icons/linearicons/Linearicons-Free.svg?w118d
// module id = ./src/assets/components/icons/linearicons/Linearicons-Free.svg?w118d
// module chunks = 7